import { createFileRoute } from "@tanstack/react-router"
import { validateInstructorSectionSearch } from "@/utils/instructorSectionSearch"
import { queryClient } from "@/queryClient"
import { getCourseOptions, getProjectOptions, getAssignmentOptions } from "@/client/@tanstack/react-query.gen"
import ProjectAssessmentEdit from "@/routes/-pages/ProjectAssessmentEdit"
import { runBackendModePrefetch } from "@/utils/routePrefetch"
import { sanitizeRouteParam } from "@/utils/routeParams"

export const Route = createFileRoute("/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit")({
  validateSearch: validateInstructorSectionSearch,
  loader: ({ params }) => {
    const assessmentId = sanitizeRouteParam(params.assessmentId) ?? ""
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getCourseOptions({ path: { course_id: params.courseId } })),
        queryClient.prefetchQuery(getProjectOptions({ path: { project_id: params.projectId } })),
        queryClient.prefetchQuery(getAssignmentOptions({ path: { assignment_id: assessmentId } })),
      ]),
    )
  },
  component: ProjectAssessmentEdit,
})
